import { useSelector } from 'react-redux'
import { UserData } from 'models/Auth'

interface PersonGeneralData {
  userData: UserData['auth']['userData']['person_general']
  hasAddressData: boolean
  hasRelativeData: boolean
}

export const usePersonGeneralData = (): PersonGeneralData => {
  const authData = useSelector((state: UserData) => state.auth)

  if (!authData.isAuth) {
    return {
      hasAddressData: false,
      hasRelativeData: false,
      userData: null
    }
  }

  const userData = authData.userData.person_general
  
  const hasAddressData =
    Boolean(
      userData.address_data?.cep &&
      userData.address_data?.address &&
      userData.address_data?.address_number &&
      userData.address_data?.neighborhood &&
      userData.address_data?.city &&
      userData.address_data?.state
    )

  const hasRelativeData =
    Boolean(
      userData.relative_data?.relative_full_name &&
      userData.relative_data?.relative_phone_number &&
      userData.relative_data?.relationship_degree
    )

  return {
    userData,
    hasAddressData,
    hasRelativeData
  }
}